import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarAction,
  MatSnackBarActions,
  MatSnackBarLabel,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { TranslocoService } from '@jsverse/transloco';

import type { SnackbarData } from '../../types/interfaces/ui/snackbar/snackbar-data';
import type { SnackbarVariant } from '../../types/interfaces/ui/snackbar/snackbar-variant';

/** Default Material icon names per variant (aligned with `bi-banner`). */
const BI_SNACKBAR_DEFAULT_ICONS: Record<SnackbarVariant, string> = {
  info: 'info',
  error: 'error',
  success: 'check_circle',
};

@Component({
  selector: 'bi-snackbar',
  imports: [MatIconButton, MatIconModule, MatSnackBarLabel, MatSnackBarActions, MatSnackBarAction],
  templateUrl: './snackbar.html',
  styleUrl: './snackbar.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'bi-snackbar',
  },
})
export class BiSnackbar {
  protected readonly data = inject<SnackbarData>(MAT_SNACK_BAR_DATA);
  private readonly snackBarRef = inject(MatSnackBarRef<BiSnackbar>);
  private readonly transloco = inject(TranslocoService);

  protected readonly closeAriaLabel = this.transloco.translate('Close');

  /** Material icon name for the leading glyph (same defaults as `bi-banner`). */
  protected readonly messageIconName = BI_SNACKBAR_DEFAULT_ICONS[this.data.variant];

  protected dismiss(): void {
    this.snackBarRef.dismiss();
  }
}
